import type { AdminGatewayAccountListFilters } from '@/api/models';

/** Count of active gateway-account-list filters, for the `FiltersPopover` badge. Excludes pagination. */
export function countActiveGatewayAccountFilters(filters: AdminGatewayAccountListFilters): number {
  return [filters.tenantCode?.length, filters.gateway?.length].filter((value) => Boolean(value)).length;
}
